import React from 'react';
import Link from 'next/link';
import { Box, Container, Typography } from '@mui/material';
import Video from 'components/Video';
import { useStyles } from './styles';
import CustomButton from 'components/CustomButton';
import WrapperBackgroundGraphics from 'components/WrapperBackgroundGraphics';
import VideoSwitcher from 'components/VideoSwitcher';
import useIsMobile from 'hooks/useIsMobile';
import { flowTrialActive } from 'utils';

export default function Header() {
  const classes = useStyles();
  const isMobile = useIsMobile();

  return (
    <WrapperBackgroundGraphics>
      <Box id="header" className={classes.root}>
        <Container>
          <Box className={classes.content}>
            <Box>
              <Typography className={classes.titleGraphical} variant="h1">
                <b>
                  Create effective <br /> science figures in <br /> minutes
                </b>
              </Typography>

              <Box py={3}>
                <Typography className={classes.descriptionGraphical}>
                  <b>
                    Visually appealing figures for your research. <br /> Browse through 75.000+{' '}
                    scientifically accurate <br /> illustrations in 80+ popular fields.
                  </b>
                </Typography>
              </Box>

              <Link href="#pricing-content">
                <CustomButton style={{ width: '90%' }}>
                  {flowTrialActive ? 'Get Started Now' : 'Subscribe Now'}
                </CustomButton>
              </Link>
            </Box>

            {isMobile && (
              <Box className={classes.videoWrapper}>
                <Video
                  className={classes.video}
                  sources={[
                    { src: '/videos/new-header-banner-new-workspace.webm', type: 'video/webm' },
                  ]}
                />
              </Box>
            )}

            {!isMobile && <VideoSwitcher />}
          </Box>
        </Container>
      </Box>
    </WrapperBackgroundGraphics>
  );
}
